{
  "_doc": "Shared palette atlas (art bible). 16x16 grid of 16px swatches in a 256px texture. Each swatch is a vertical gradient: 'top' (lit) to 'bottom' (shade). Index = row*16 + col, assigned in list order. Append new swatches at the end; never reorder (it would re-colour every model).",
  "size": 256,
  "grid": 16,
  "swatches": [
    { "name": "bark_dark", "top": "#5a4636", "bottom": "#3b2d23" },
    { "name": "bark_birch", "top": "#d9d4c7", "bottom": "#a7a194" },
    { "name": "leaf_summer", "top": "#6f8f45", "bottom": "#46602c" },
    { "name": "leaf_autumn", "top": "#b7792f", "bottom": "#7d4c1f" },
    { "name": "leaf_pine", "top": "#3f5e3c", "bottom": "#253a25" },
    { "name": "leaf_dead", "top": "#8a7a52", "bottom": "#5d5137" },
    { "name": "grass", "top": "#7c9450", "bottom": "#55693a" },
    { "name": "grass_dry", "top": "#a69b62", "bottom": "#776e45" },
    { "name": "moss", "top": "#5d7a3c", "bottom": "#3d5228" },
    { "name": "rock", "top": "#8b8a84", "bottom": "#5d5c58" },
    { "name": "rock_dark", "top": "#5f5e5a", "bottom": "#3d3c39" },
    { "name": "dirt", "top": "#7a6249", "bottom": "#54432f" },
    { "name": "mud", "top": "#5a4a38", "bottom": "#3a2f24" },
    { "name": "sand", "top": "#cdbb8e", "bottom": "#a8966b" },
    { "name": "snow", "top": "#f2f4f6", "bottom": "#c9d0d8" },
    { "name": "water_murky", "top": "#4d5d55", "bottom": "#2f3b36" },

    { "name": "concrete", "top": "#a6a49c", "bottom": "#7c7a73" },
    { "name": "concrete_dark", "top": "#74726c", "bottom": "#53524d" },
    { "name": "brick_red", "top": "#8e4c3a", "bottom": "#653427" },
    { "name": "brick_yellow", "top": "#b39a6a", "bottom": "#86724c" },
    { "name": "siding_white", "top": "#d6d3c8", "bottom": "#a9a597" },
    { "name": "siding_blue", "top": "#7d93a1", "bottom": "#5a6c78" },
    { "name": "siding_green", "top": "#8a9a7a", "bottom": "#647158" },
    { "name": "siding_yellow", "top": "#c9b57a", "bottom": "#9a8855" },
    { "name": "roof_shingle", "top": "#4e4a47", "bottom": "#33302e" },
    { "name": "roof_red", "top": "#7d3b2e", "bottom": "#55271e" },
    { "name": "asphalt", "top": "#4a4a4a", "bottom": "#333333" },
    { "name": "road_paint_white", "top": "#e4e1d6", "bottom": "#bdb9ad" },
    { "name": "road_paint_yellow", "top": "#d8b240", "bottom": "#a8872c" },
    { "name": "glass", "top": "#8fa6ad", "bottom": "#55686e" },
    { "name": "glass_dirty", "top": "#7b8577", "bottom": "#4c5249" },
    { "name": "tile_floor", "top": "#c8c3b4", "bottom": "#a19c8e" },

    { "name": "wood_raw", "top": "#a7825a", "bottom": "#7a5c3d" },
    { "name": "wood_dark", "top": "#6e4f35", "bottom": "#4a3423" },
    { "name": "wood_weathered", "top": "#8e8577", "bottom": "#655d52" },
    { "name": "wood_painted_white", "top": "#cfcabd", "bottom": "#a29c8e" },
    { "name": "plywood", "top": "#c2a274", "bottom": "#957a53" },
    { "name": "rust", "top": "#8a5232", "bottom": "#5e3620" },
    { "name": "rust_dark", "top": "#5c3a28", "bottom": "#3b2519" },
    { "name": "metal_bare", "top": "#9da1a3", "bottom": "#6c7072" },
    { "name": "metal_dark", "top": "#55595c", "bottom": "#383b3d" },
    { "name": "metal_gun", "top": "#3c3f42", "bottom": "#232527" },
    { "name": "paint_red_faded", "top": "#a14a3e", "bottom": "#73332a" },
    { "name": "paint_blue_faded", "top": "#4d6a86", "bottom": "#35495d" },
    { "name": "paint_green_faded", "top": "#5e7a55", "bottom": "#41553b" },
    { "name": "paint_yellow_faded", "top": "#c9a744", "bottom": "#977c30" },
    { "name": "paint_white_faded", "top": "#d8d5cc", "bottom": "#aaa69c" },
    { "name": "rubber_black", "top": "#2e2e2e", "bottom": "#1b1b1b" },

    { "name": "plastic_black", "top": "#353535", "bottom": "#202020" },
    { "name": "plastic_white", "top": "#dedbd3", "bottom": "#b3afa5" },
    { "name": "polymer_tan", "top": "#a8956d", "bottom": "#7d6d4e" },
    { "name": "military_olive", "top": "#5d6340", "bottom": "#40452b" },
    { "name": "military_tan", "top": "#a99a74", "bottom": "#7c7054" },
    { "name": "stencil_white", "top": "#e6e3da", "bottom": "#c2beb3" },
    { "name": "cardboard", "top": "#b2915f", "bottom": "#866b44" },
    { "name": "paper", "top": "#e5dfcf", "bottom": "#bdb6a4" },
    { "name": "cloth_denim", "top": "#4f6582", "bottom": "#36465b" },
    { "name": "cloth_olive", "top": "#5f6447", "bottom": "#42462f" },
    { "name": "cloth_khaki", "top": "#a69873", "bottom": "#7a6f53" },
    { "name": "cloth_black", "top": "#2f2f31", "bottom": "#1c1c1e" },
    { "name": "cloth_red", "top": "#8a3a34", "bottom": "#5f2723" },
    { "name": "cloth_grey", "top": "#7c7d7f", "bottom": "#56575a" },
    { "name": "leather_brown", "top": "#6b4a32", "bottom": "#463020" },
    { "name": "fabric_orange", "top": "#c46a2c", "bottom": "#8e4b1e" },

    { "name": "skin_1", "top": "#f1c8a5", "bottom": "#c99e7e" },
    { "name": "skin_2", "top": "#dfaa82", "bottom": "#b78562" },
    { "name": "skin_3", "top": "#c08a62", "bottom": "#986947" },
    { "name": "skin_4", "top": "#9a6744", "bottom": "#744b30" },
    { "name": "skin_5", "top": "#6e4a32", "bottom": "#4e3322" },
    { "name": "skin_6", "top": "#4d3324", "bottom": "#352218" },
    { "name": "zombie_skin", "top": "#8d9779", "bottom": "#636b54" },
    { "name": "zombie_bruise", "top": "#6f5f6e", "bottom": "#4c404b" },
    { "name": "blood_fresh", "top": "#7d1717", "bottom": "#520e0e" },
    { "name": "blood_dry", "top": "#4a1a16", "bottom": "#2f100d" },
    { "name": "bone", "top": "#ddd3b8", "bottom": "#b2a78c" },
    { "name": "hair_dark", "top": "#3a2c22", "bottom": "#241b15" },
    { "name": "hair_light", "top": "#a88a5d", "bottom": "#7c6541" },
    { "name": "eye_glow_zombie", "top": "#f0e3a0", "bottom": "#c9b862" },
    { "name": "teeth", "top": "#d8cfaa", "bottom": "#aea37f" },
    { "name": "gore_meat", "top": "#8e3b35", "bottom": "#622622" },

    { "name": "signal_loot_orange", "top": "#ff8a1f", "bottom": "#d96a0a" },
    { "name": "signal_radiation", "top": "#9cff3a", "bottom": "#62c41a" },
    { "name": "signal_infestation", "top": "#b3122a", "bottom": "#7a0b1c" },
    { "name": "rarity_common", "top": "#e8e8e8", "bottom": "#c4c4c4" },
    { "name": "rarity_uncommon", "top": "#6cc24a", "bottom": "#4a8f31" },
    { "name": "rarity_rare", "top": "#3f8fe0", "bottom": "#2a68a8" },
    { "name": "rarity_epic", "top": "#a65be0", "bottom": "#7a3ca8" },
    { "name": "rarity_legendary", "top": "#f2b632", "bottom": "#c48a18" },
    { "name": "light_warm", "top": "#ffd9a0", "bottom": "#e8b878" },
    { "name": "light_cold", "top": "#d6ecff", "bottom": "#a8c8e8" },
    { "name": "neon_red", "top": "#ff3b3b", "bottom": "#c42020" },
    { "name": "hazard_yellow", "top": "#f2c230", "bottom": "#c49a1c" },
    { "name": "hazard_black", "top": "#262626", "bottom": "#141414" },
    { "name": "debug_magenta", "top": "#ff00ff", "bottom": "#c000c0" }
  ]
}
